import React, { useCallback } from 'react';
import { devLogger } from 'utilities/devLogger';
import {
    doTagOnProcessCancelledEvent,
    doTagOnProcessCompletedEvent,
    doTagOnProcessErrorEvent,
    doTagOnProcessInfoEvent,
} from 'components/shared/XpressId/tagging';

export const withHandlersTagging = (WrappedComponent, isEventLoggingActive = false) => {
    const ComponentWithHandlersTagging = ({
        onProcessCancelled,
        onProcessError,
        onProcessEvents,
        onProcessCompleted,
        ...otherProps
    }) => {
        const handleProcessCancelled = useCallback(data => {
            isEventLoggingActive && devLogger.log('ProcessCancelled', data);
            doTagOnProcessCancelledEvent();
            onProcessCancelled?.(data);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        const handleProcessError = useCallback(
            data => {
                isEventLoggingActive && devLogger.error('ProcessError', data);
                doTagOnProcessErrorEvent(data);
                onProcessError?.(data);
                // eslint-disable-next-line react-hooks/exhaustive-deps
            },
            [onProcessError]
        );

        const handleProcessEvents = useCallback(data => {
            isEventLoggingActive && devLogger.info('ProcessEvents', data);
            doTagOnProcessInfoEvent(data);
            onProcessEvents?.(data);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        const handleProcessCompleted = useCallback(data => {
            isEventLoggingActive && devLogger.info('ProcessEvents', data);
            doTagOnProcessCompletedEvent();
            onProcessCompleted?.(data);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        return (
            <WrappedComponent
                {...otherProps}
                onProcessCancelled={handleProcessCancelled}
                onProcessError={handleProcessError}
                onProcessEvents={handleProcessEvents}
                onProcessCompleted={handleProcessCompleted}
            />
        );
    };
    ComponentWithHandlersTagging.displayName = `WithHandlersTagging(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
    })`;

    return ComponentWithHandlersTagging;
};
